@if(helpText) {
  <i class="bi bi-question-circle-fill" [ngbTooltip]="tipContent" [tooltipClass]="'tooltip-custom'"></i>
}

<ng-template #tipContent>
  <div class="content" [innerHtml]="helpText | translate"></div>
</ng-template>
